import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentResetService {
  private resetFormSubject = new Subject<void>();
  resetForm$ = this.resetFormSubject.asObservable();

  private inactivityTimer: any;
  private readonly INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minutes in milliseconds
  private isInactivityTimerActive = false;

  triggerFormReset(): void {
    this.resetFormSubject.next();
  }

  startInactivityTimer(): void {
    this.stopInactivityTimer();

    this.inactivityTimer = setTimeout(() => {
      console.log('[Payment Inactivity Timer] 15 minutes elapsed. Resetting payment form.');
      this.triggerFormReset();
      this.isInactivityTimerActive = false;
    }, this.INACTIVITY_TIMEOUT);

    this.isInactivityTimerActive = true;
  }


  stopInactivityTimer(): void {
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = null;
    }
    this.isInactivityTimerActive = false;
  }

  resetInactivityTimer(): void {
    this.stopInactivityTimer();
    this.startInactivityTimer();
  }

  isTimerActive(): boolean {
    return this.isInactivityTimerActive;
  }
}